module.exports = __webpack_public_path__ + "media/components/app-store/static/s5-cd69afdc129f6f6ffee013a2364f348a.png";